// main-layout.component.ts
import { Component, ElementRef, Renderer2, ViewChild, inject } from '@angular/core';
import { Menu, NavService } from '../../services/navservice';
import { Subscription, filter } from 'rxjs';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../../common/navbar/navbar.component';
import { SidebarComponent } from '../../common/sidebar/sidebar.component';
import { FooterComponent } from '../../common/footer/footer.component';
import { TapToTopComponent } from '../../common/tap-to-top/tap-to-top.component';
import { BreadcrumbComponent } from '../../components/ui/nav-tabs/breadcrumb/components/breadcrumb/breadcrumb.component';
import { LoaderService } from '../../../core/services/loader.service';
import { LoaderComponent } from '../../common/loader/loader.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    TapToTopComponent,
    BreadcrumbComponent,
    LoaderComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  @ViewChild('sidebar') sidebar!: SidebarComponent;

  private readonly loaderService = inject(LoaderService);

  // Only shows loader for 'main' context - dialogs use their own context
  isLoading = this.loaderService.isLoading;
  message = this.loaderService.message;

  menuItems!: Menu[];
  menuitemsSubscribe$!: Subscription;

  constructor(
    private readonly navServices: NavService,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {
    const html = document.querySelector('html');

    if (window.innerWidth <= 992) {
      html?.setAttribute('data-toggled', 'close');
    }
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      window.scrollTo(0, 0);
    });
  }

  ngOnInit(): void {
    this.menuitemsSubscribe$ = this.navServices.items.subscribe((items: any) => {
      this.menuItems = items;
    });
  }

  ngOnDestroy(): void {
    this.menuitemsSubscribe$?.unsubscribe();
  }

  clearNavDropdown(): void {
    this.menuItems?.forEach((a: any) => {
      a.active = false;
      a?.children?.forEach((b: any) => {
        b.active = false;
        b?.children?.forEach((c: any) => {
          c.active = false;
        });
      });
    });
  }

  clickOnBody(): void {
    document.querySelector('#responsive-overlay')?.classList.remove('active');
    const html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (window.innerWidth <= 992) {
      html?.setAttribute('data-toggled', 'close');
    }
    html?.removeAttribute('data-icon-text');

    this.menuItem.active = !this.menuItem.active;

    if (html.getAttribute('data-nav-layout') === 'horizontal' && window.innerWidth >= 992) {
      this.clearNavDropdown();
    }
    const navStyle = document.documentElement.getAttribute('data-nav-style');
    if (
      navStyle === 'menu-click' ||
      navStyle === 'menu-hover' ||
      navStyle === 'icon-click' ||
      navStyle === 'icon-hover'
    ) {
      document.querySelector('.double-menu-active')?.setAttribute('style', 'display: none;');
    }
  }

  menuItem = {
    active: false,
  };

  onSidebarToggle(): void {
    if (this.sidebar) {
      this.sidebar.toggleSidebar();
    }
  }

  clearToggle(): void {
    const html = this.elementRef.nativeElement.ownerDocument.documentElement;
    html?.setAttribute('data-toggled', 'close');
    document.querySelector('#responsive-overlay')?.classList.add('active');
  }
}
